import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

interface IButton {
  children: React.ReactNode;
  variant: 'primary' | 'secondary' | 'delete';
  onClick?: () => void;
  className?: string;
  tag?: 'Link' | 'Button' | 'a';
  to?: string;
  disabled?: boolean;
}
export default function Button({
  children,
  variant,
  onClick,
  className,
  tag = 'Button',
  to = '',
  disabled = false,
}: IButton) {
  const classNameVariant = clsx(
    className,
    'py-2.5 px-2.5 transition duration-300 [&_path]:transition [&_path]:duration-300 border text-12 smallMobile:text-base font-semibold rounded-6 whitespace-nowrap flex justify-center',
    variant === 'primary' && !disabled
      ? 'border-blue text-white bg-blue hover:bg-white hover:text-blue [&_path]:hover:fill-blue'
      : null,
    variant === 'secondary'
      ? 'border-blue bg-white text-blue hover:bg-blue hover:text-white [&_path]:hover:fill-white'
      : null,
    variant === 'delete' && !disabled
      ? 'border-red bg-red text-white hover:bg-white hover:text-red hover:border-red'
      : null,
    disabled && variant === 'primary'
      ? 'border-blue text-white bg-blue opacity-50'
      : null,
    disabled && variant === 'delete'
      ? 'border-red bg-red text-white opacity-50'
      : null
  );
  return (
    <>
      {tag === 'Link' ? (
        <Link to={to} onClick={onClick} className={classNameVariant}>
          {children}
        </Link>
      ) : null}
      {tag === 'Button' ? (
        <button
          type={'button'}
          onClick={onClick}
          className={classNameVariant}
          disabled={disabled}
        >
          {children}
        </button>
      ) : null}
      {tag === 'a' ? (
        <a href={to} className={classNameVariant}>
          {children}
        </a>
      ) : null}
    </>
  );
}
